{
  "srTitle": "Anti Human Safari Project — Drohnenschutz für Zivilisten in Cherson, Ukraine",
  "logoAlt": "Logo des Anti Human Safari Project",
  "intro": "Wir stellen Schutzausrüstung gegen Angriffe kleiner Drohnen für Freiwillige, Rettungsdienste und Beschäftigte kritischer Infrastruktur in Cherson, Ukraine, bereit.",
  "safari": "Seit Sommer 2024 werden Zivilisten in Cherson systematisch von der russischen Armee mit Videodrohnen gejagt – in einer Terrorkampagne, die als „Human Safari“ bekannt ist.",
  "unLink": "UN-Kommission erkennt Human Safari als Kriegsverbrechen an",
  "donateNow": "Jetzt spenden",
  "donateMonthly": "Monatlich spenden",
  "otherWays": "andere Möglichkeiten zu spenden",
  "instagram": "Instagram",
  "pastFundraisers": "Frühere Spendenaktionen:",
  "fundraiser2025": "Spendenaktion 2025",
  "donateVia": "Spenden über:",
  "charityRef": "über eine britische Wohltätigkeitsorganisation, mit Verwendungszweck:",
  "germanCharityRef": "über eine deutsche Wohltätigkeitsorganisation, mit Verwendungszweck:",
  "copy": "Kopieren",
  "copied": "Kopiert!",
  "close": "Schließen",
  "viewMedia": "Medien ansehen",
  "andrushenkoCredit": "Oleksandr Andrushenko, Fotokorrespondent des Mediums Vgoru",
  "fruitSellerDescription": "Obstverkäufer von einer Glasfaserdrohne verfolgt",
  "khersonPoliceCredit": "von @khersonpolice",
  "firefighterDescription": "Ein Feuerwehrmann löscht ein Auto nach einem Angriff der „Human Safari“, dahinter liegt ein Opfer",
  "previousMedia": "Zurück",
  "nextMedia": "Weiter",
  "fpvDroneDescription": "FPV-Drohne unterwegs auf „Human Safari“",
  "busAttackDescription": "Einer von vielen FPV-Drohnenangriffen auf öffentliche Verkehrsmittel",
  "notFoundTitle": "Seite nicht gefunden",
  "notFoundMessage": "Diese Seite existiert nicht. Möglicherweise wurde sie verschoben oder der Link ist falsch.",
  "backHome": "Zurück zur Startseite",
  "droneDetectorDescription": "Drohnendetektoren sind kleine Handgeräte, die warnen, wenn eine Drohne in der Nähe ist",
  "vestDescription": "Leichte Schutzwesten können die Schwere von Verletzungen durch einen Drohnenangriff verringern"
}
